import IntroductionWithImage from "../../components/IntroductionWithImage";
import MainImageCarousel from "../../components/MainImageCarousel";
import StickyNavAndFooter from "../layout/StickyNavAndFooter";
import {
    choiceOfAWisePoem,
    lifeActivitiesCards} from "../../data/data";
import { Box, Card, CardBody, Text, Tooltip } from "@chakra-ui/react";
import choiceOfAWise from '../../resources/images/choiceOfAWise.png'
import { bodyBGColor, headingSecondaryFont, headingTertiaryFont, primaryColor, primaryFontSize, secondaryColorTwo } from "../../config";
import DividerAbsoluteCenter from "../../components/DividerAbsoluteCenter";
import ElevatedCardCarousal from "../../components/Carousels/ElevatedSideImageCardCarousal";

export default function LifeActivities() {

    return (
        <StickyNavAndFooter>
            <MainImageCarousel />
            <Card>
                <CardBody>
                    <IntroductionWithImage img={choiceOfAWise}>
                        {choiceOfAWisePoem}
                        <br />
                    </IntroductionWithImage>
                </CardBody>
            </Card>


            <br />

            <DividerAbsoluteCenter bg={bodyBGColor} dividerBorderColor={primaryColor}>
                <Box
                    display={"flex"}
                    alignItems={"center"}
                    flexDir={"column"}
                >
                    <Text fontSize={{ base: primaryFontSize, md: headingSecondaryFont }}
                        color={primaryColor}
                    >
                        Joy Or Suffering?
                    </Text>
                    <Text fontSize={{ base: primaryFontSize, md: primaryFontSize }} color={secondaryColorTwo}
                        alignSelf={"center"}>
                        We choose our Activities every moment...
                    </Text>
                </Box>
            </DividerAbsoluteCenter>
            <br />

            <Box
                display={{ base: "block", "lg": "flex" }}
                flexDir={{ base: "column", lg: "row" }}
                justifyContent={"space-evenly"} mt={0}>
                <ElevatedCardCarousal elevatedCards={lifeActivitiesCards} />
            </Box>

            <Box textAlign={"center"} as="a" href={"#contactUs"}>
                <Tooltip label="" aria-label="Contact Us for more information">
                    <Box m='auto' fontSize={headingTertiaryFont}
                        color={primaryColor}>
                        Contact Us for more information
                    </Box>
                </Tooltip>
            </Box>
        </StickyNavAndFooter>
    )
}